import script from "./ProactiveTriggersTrendChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProactiveTriggersTrendChart.vue?vue&type=script&lang=ts&setup=true"

import "./ProactiveTriggersTrendChart.vue?vue&type=style&index=0&id=2a972430&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a972430"]])

export default __exports__